import { FC } from "react";
import { FormikProps } from "formik";
import { TextInput } from "components/core";

export interface LimitFormProps {
  form: FormikProps<any>;
  labelText?: string;
}

const LimitForm: FC<LimitFormProps> = ({
  form,
  labelText = "Percentage to accept",
}) => {
  return (
    <div className="space-y-6">
      {" "}
      <div>
        <TextInput
          id="percentage"
          type="number"
          label={labelText} // Use the prop for flexibility
          required
          placeholder="e.g., 10.5"
          // Displaying max info within the label or helper text might be better than postText
          // postText={`Max: ${form.values.expected?.toFixed(4)}%`}
          values={form.values}
          handleChange={form.handleChange}
          handleBlur={form.handleBlur}
          errors={form.errors}
          touched={form.touched}
          min={0}
          max={form.values.expected} // Keep validation constraint
          step={0.0001} // Allow for more precise percentage input
          // inputClassName="text-right pr-10" // Align text right for numbers, adjust padding if using postText/icon
          postText="%" // Add % symbol directly after input
        />
        <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
          Enter the final percentage you wish to accept from this reinsurer.
        </p>
      </div>
    </div>
  );
};

export default LimitForm;
